import classnames from 'classnames'
import { ForwardedRef, HTMLProps, PropsWithChildren, ReactNode, forwardRef } from 'react'

import { Icon } from './icon'

interface CheckboxProps extends Omit<HTMLProps<HTMLInputElement>, 'label'> {
  /**
   * Text that gets displayed on the right side of the checkbox
   */
  label?: ReactNode

  checked: boolean
  isSmall?: boolean
}

function CheckboxComponent(
  { className, label, isSmall, children, ...props }: PropsWithChildren<CheckboxProps>,
  ref: ForwardedRef<HTMLInputElement>
) {
  const checked = props.checked ?? props.defaultChecked

  return (
    <label
      className={classnames(className, 'group flex items-center', {
        'text-gray-400 dark:text-gray-500': props.disabled,
        'h-7 text-sm': !isSmall,
        'h-6 text-2xs': isSmall,
      })}
    >
      <div className="relative mr-2 flex">
        <input
          {...props}
          ref={ref}
          type="checkbox"
          className={classnames(
            'h-4 w-4 cursor-pointer appearance-none rounded-sm border ring-gray-300 focus:outline-none focus-visible:ring-2', // Base
            'border-gray-200 bg-white dark:border-gray-600 dark:bg-gray-800', // Normal
            'group-hover:border-gray-400', // Hover
            'checked:border-blue-400 checked:bg-blue-400 group-hover:checked:border-blue-500 group-hover:checked:bg-blue-500 dark:checked:border-blue-400 dark:checked:bg-blue-400 dark:group-hover:checked:border-blue-500', // Checked
            'disabled:border-gray-100 disabled:bg-gray-100 disabled:checked:border-gray-400 disabled:checked:bg-gray-400 dark:disabled:bg-gray-600 dark:disabled:checked:border-gray-600 dark:disabled:checked:bg-gray-600 dark:disabled:group-hover:border-gray-600' // Disabled
          )}
        />
        {checked && <Icon name="done" className="absolute left-0.5 top-0.5 text-gray-50" width={12} />}
      </div>
      {label ?? children}
    </label>
  )
}

export const Checkbox = forwardRef(CheckboxComponent)
